import { registerLocale, setDefaultLocale } from "react-datepicker";
import { nl } from 'date-fns/locale';
export function initializeDatePickerEnvironment() {
    //register locales to prevent a lot of warnings being generated & decreasing performance on opening datepicker
    registerLocale("nl", nl);
    setDefaultLocale("nl");
}
